module.exports = __webpack_public_path__ + "static/media/Aika.e33fd8e6.png";